import * as H from 'history';
import React, { FC, MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import Skeleton from 'react-loading-skeleton';
import { NavLink } from 'react-router-dom';

import { FoodTrayTemplate } from '../../models';
import { GastronomGrid } from '..';
import Button, { Theme } from '../button/Button';
import SideBySide from '../side-by-side/SideBySide';

import './FoodTrayTemplateLink.scss';

interface Props {
  template: FoodTrayTemplate | undefined;
  link: string | H.LocationState;
  isDuplicateLoading?: boolean;
  onDuplicateTemplate?: () => void;
}

const FoodTrayTemplateLink: FC<Props> = ({ template, onDuplicateTemplate, isDuplicateLoading = false, link }) => {
  const { t } = useTranslation();

  const handleDuplicateTemplate = (evt: MouseEvent) => {
    evt.stopPropagation();
    onDuplicateTemplate();
  };

  const renderLink = () => {
    return (
      <div className='food-tray-template'>
        <SideBySide>
          <NavLink className='nav-link' to={link} activeClassName='active-link'>
            <p className='name'>{template.name}</p>
          </NavLink>
          {onDuplicateTemplate && (
            <Button
              theme={Theme.TRANSPARANT}
              onClickCallback={handleDuplicateTemplate}
              icon='Duplicate'
              isLoading={isDuplicateLoading}>
              {t('lblDuplicate')}
            </Button>
          )}
        </SideBySide>
        <NavLink className='nav-link' to={link} activeClassName='active-link'>
          <GastronomGrid foodTrays={(template.foodLines || [])[0]?.foodTrays || []} isOverview isTabbable={false} />
        </NavLink>
      </div>
    );
  };

  const renderSkeleton = () => {
    return (
      <div className='food-tray-template'>
        <SideBySide>
          <Skeleton width={250} height={30} />
          <Skeleton width={150} height={30} />
        </SideBySide>
        <Skeleton width='100%' height={154} />
      </div>
    );
  };

  return !!template ? renderLink() : renderSkeleton();
};

export default FoodTrayTemplateLink;
